import React, { useState } from 'react';
import { Button, Card, CardContent, Backdrop, CircularProgress } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useSnackbar } from 'notistack';
import { DropzoneArea } from 'material-ui-dropzone';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Api from '../../../Api';
import Modal from '../../../components/Modal/Modal';

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    maxHeight: 'calc(100vh - 200px) !important'
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const useStyles = makeStyles(theme => ({
  dropzone: {
    position: 'relative',
    width: '100%',
    height: '40%',
    minHeight: '100px',
    backgroundColor: '#F0F0F0',
    border: 'dashed',
    borderColor: '#C8C8C8',
    cursor: 'pointer',
    boxSizing: 'border-box'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000,
    color: '#fff'
  }
}));

// folderId: target folder for the uploaded files.
const UploadDialog = ({ handleClose, visibility, folderId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const styles = useStyles();

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChangeFiles = files => {
    setFiles(files);
  };

  const handleOnDocRejected = () => {
    enqueueSnackbar('Archivo no válido! Recordá que debe tener un tamaño máximo de 15mb.', {
      anchorOrigin: { vertical: 'top', horizontal: 'center' },
      variant: 'error'
    });
  };

  const handleCloseDismiss = () => {
    handleClose();
  };

  // Uploads the binary, then persists the drive_files row. Both steps are
  // awaited; any failure rejects so the caller can count only real successes.
  const createDriveFile = async file => {
    const data = new FormData();
    data.append('file', file);
    const response = await Api.post('/drive_files/upload', data);
    await Api.post('/drive_files', {
      folder_id: folderId,
      name: file.name,
      url: response.data.fileUrl
    });
  };

  const handleUpload = async event => {
    event.preventDefault();
    setLoading(true);

    var succeeded = 0;
    var failed = 0;
    for (const file of files) {
      try {
        await createDriveFile(file);
        succeeded += 1;
      } catch (error) {
        failed += 1;
      }
    }

    if (succeeded > 0) {
      enqueueSnackbar(succeeded === 1 ? 'Archivo subido exitosamente!' : 'Archivos subidos exitosamente!', {
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        variant: 'success'
      });
    }
    if (failed > 0) {
      enqueueSnackbar('No se pudieron subir ' + failed + ' archivo(s), intenta nuevamente.', {
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        variant: 'error'
      });
    }

    setLoading(false);
    setFiles([]);
    handleClose(true);
  };

  return (
    <div>
      <Modal handleClose={handleCloseDismiss} visibility={visibility} title="Subir Archivos" maxWidth="md">
        <form onSubmit={handleUpload}>
          <DialogContent dividers>
            <Card>
              <CardContent>
                <DropzoneArea
                  dropzoneClass={styles.dropzone}
                  acceptedFiles={['image/jpeg', 'image/png', 'application/pdf', 'application/msword']}
                  onChange={handleChangeFiles}
                  showFileNames
                  dropzoneText="Arraste los archivos aquí o haga click para seleccionar"
                  showAlerts={false}
                  filesLimit={10}
                  maxFileSize={15000000}
                  onDropRejected={handleOnDocRejected}
                />
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions>
            <Button disabled={files.length === 0} type="submit" color="primary">
              Subir
            </Button>
          </DialogActions>
        </form>
      </Modal>
      <Backdrop className={styles.backdrop} open={loading}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress color="inherit" />
          <Typography variant="h6" style={{ marginTop: 16, color: '#fff' }}>
            Subiendo archivos...
          </Typography>
        </Box>
      </Backdrop>
    </div>
  );
};

export default UploadDialog;
